import { render, staticRenderFns } from "./ClientUsers.vue?vue&type=template&id=4f504610&scoped=true&"
import script from "./ClientUsers.vue?vue&type=script&lang=js&"
export * from "./ClientUsers.vue?vue&type=script&lang=js&"
import style0 from "./ClientUsers.vue?vue&type=style&index=0&id=4f504610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f504610",
  null
  
)

export default component.exports